import React, { useState } from 'react';
import {
    PlusOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Modal,
    Select,
    Row,
    Col,
    InputNumber,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function AddFormModal({ categories, brands }) {

    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/product/', data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/product/'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate(values))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }
    return (
        <div>
            {contextHolder}
            <Button
                type='primary'
                icon={<PlusOutlined />}
                onClick={() => setOpen(true)}
            >เพิ่ม</Button>
            <Modal
                open={open}
                title="เพิ่มสินค้า"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addProduct'
                >
                    <Form.Item
                        name="name"
                        label="รุ่น"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="ประเภท"
                                name="category"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="เลือกประเภทสินค้า"
                                >
                                    {
                                        categories.map(item => <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="แบรนด์"
                                name="brand"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="เลือกแบรนด์สินค้า"
                                >
                                    {
                                        brands.map(item => <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={8}>
                            <Form.Item
                                label="ราคาขายต่ำสุด"
                                name="min_price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={8}>
                            <Form.Item
                                label="ราคาปกติ"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={8}>
                            <Form.Item
                                label="ราคาขาย"
                                name="selling_price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                name="color"
                                label="สี"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item name="description" label="รายละเอียด">
                                <Input.TextArea rows={2} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>

    )
}
